import * as Sentry from '@sentry/react';
import { browserTracingIntegration } from '@sentry/react';

import { userStore } from './userStore';

export const initSentry = () => {
  if (import.meta.env.PROD) {
    Sentry.init({
      dsn: 'https://cb9e729b58a8407ab64c54cbdb643145@o318413.ingest.sentry.io/5912010',
      integrations: [browserTracingIntegration(), Sentry.replayIntegration()],
      tracesSampleRate: 0.1,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  }
};

export const sendMonitoringEvent = (error: any) => {
  Sentry.captureException(error, (scope: any) => {
    const user = userStore.get();
    if (user) {
      scope.setUser({ id: String(user.id) });
      scope.setExtras(error?.response?.data);
    }
    return scope;
  });
};

export const captureUserForMonitoring = (userId: string) => {
  Sentry.setUser({ id: userId });
};
